import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import Select, { createFilter } from 'react-select';
import { useCookies } from 'react-cookie';
import SimpleValue from 'react-select-simple-value';
import { Button, Col, Row } from 'react-bootstrap';
import { Link, navigate } from "raviger";
import { AuthContext } from "../accounts/AccountsReducer";
import { SystemErrorContext } from '../components/SystemError';

function OrganizationManagement(organization) {

  const { dispatch, state } = useContext(AuthContext);
  const { setShowSystemError } = useContext(SystemErrorContext);

  const path = window.location.pathname;
  const org_slug = path.split('/')[1];

  return (
    <>
    <Row className='ms-auto me-auto align-bottom' style={{marginTop:"95px"}}>
      <h1 style={{fontSize:"60px", textTransform: 'capitalize'}}>{state.organization.name} - Manage Organization</h1>
    </Row>
    <Col xs={{ span:5 }} className="border rounded border-light shadow-sm ms-auto me-auto mb-auto" style={{minWidth:"572px"}}>
    {state.user.is_superuser || state.user.user_perms ? 
      <>
        <Row className="ms-1 me-1">
          <Col style={{marginRight:"-15px"}}>
            <Link href={'/' + org_slug + '/manage/accounts'} style={{textDecoration:"none"}}><Button size="lg" className="btn-primary mt-3 d-block w-100">Manage Users</Button></Link>
          </Col>
          <Col>
            <Link href={'/' + org_slug + '/manage/accounts/access_tokens'} style={{textDecoration:"none"}}><Button size="lg" className="btn-primary mt-3 d-block w-100">Manage Access</Button></Link>
          </Col>
        </Row>
        <Row className="ms-1 me-1">
          <Col style={{marginRight:"-15px"}}>
            <Link href={'/' + org_slug + '/manage/shelters'} style={{textDecoration:"none"}}><Button size="lg" className="btn-primary mt-2 d-block w-100">Manage Shelters</Button></Link>
          </Col>
          <Col>
            <Link href={'/' + org_slug + '/manage/members'} style={{textDecoration:"none"}}><Button size="lg" className="btn-primary mt-2 d-block w-100">Manage Field Members</Button></Link>
          </Col>
        </Row>
        <Row className="ms-1 me-1">
          <Col>
            <Link href={`/${org_slug}/manage/owners`} style={{textDecoration:"none"}}><Button size="lg" className="btn-primary mt-2 d-block w-100">Manage Preregistration</Button></Link>
          </Col>
        </Row>
        <Row className="ms-1 me-1">
          <Col>
            <Link href={`/${org_slug}/manage/organization/edit`} style={{textDecoration:"none"}}><Button size="lg" className="btn-primary mt-2 d-block w-100">Update Organization</Button></Link>
          </Col>
        </Row>
      </>
    : ""}
      <Row className="ms-1 me-1">
        <Link href={`/${org_slug}`} className="d-block w-100" style={{textDecoration:"none"}}><Button size="lg" className="btn-primary mt-2 mb-3 d-block w-100">Return to Incidents</Button></Link>
      </Row>
    </Col>
    </>
  );
}

export default OrganizationManagement;
